import { Radio } from 'lucide-react';

export function CrmSignalsPage() {
  return (
    <div className="flex items-center justify-center h-[50vh] text-muted-foreground">
      <div className="text-center space-y-2">
        <Radio className="h-8 w-8 mx-auto opacity-40" />
        <p>Select Tenders or News from the sidebar.</p>
      </div>
    </div>
  );
}
